export default [
    {
        path: '',
        name: 'parlament.index',
        component: () => import('@/views/parlament/Index.vue'),
        props: (route) => ({
            category: route.query.category || "parlamentskii-kontrol",
        }),
    },
];